import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  communicationReportsTypes,
  CommunicationsDocument,
} from '../../../../model';
import documentsRepository from '../../../../repositories/documents/documents-repository';
import { AsyncThunkConfig } from '../../../async-thunk-config';
import {
  CommunicationsError,
  CommunicationsState,
} from './communications-types';

export const downloadCommunicationDocuments = createAsyncThunk<
  CommunicationsDocument[],
  void,
  AsyncThunkConfig<CommunicationsError>
>('download-communications-documents', async (_, thunkApi) => {
  try {
    const state: CommunicationsState =
      thunkApi.getState().features.documents.communications;
    const filter = { ...state.filter };
    const otherTypes = filter.other ?? [];
    const hasReport = otherTypes.includes('RENDICONTO_CDL');
    if (hasReport) {
      const typesToAdd = communicationReportsTypes.filter(
        (item) => item !== 'RENDICONTO_CDL' && !otherTypes.includes(item as any)
      );
      filter.other = [...otherTypes, ...typesToAdd];
    }

    const benefits = filter.benefits ?? [];
    if (
      benefits.includes('LETTERA_BENVENUTO_NGA_SMART') &&
      !benefits.includes('LETTERA_BENVENUTO_MONO_NGA_SMART')
    ) {
      filter.benefits = [...(filter.benefits ?? []), 'LETTERA_BENVENUTO_MONO_NGA_SMART'];
    }
    if (
      benefits.includes('LETTERA_BENVENUTO_NGA') &&
      !benefits.includes('LETTERA_BENVENUTO_MONO_NGA_FULL')
    ) {
      filter.benefits = [...(filter.benefits ?? []), 'LETTERA_BENVENUTO_MONO_NGA_FULL'];
    }
    if (
      benefits.includes('LETTERA_BENVENUTO_MAX') &&
      !benefits.includes('LETTERA_BENVENUTO_MONO_MAX')
    ) {
      filter.benefits = [...(filter.benefits ?? []), 'LETTERA_BENVENUTO_MONO_MAX'];
    }

    const hasAdvExpired = filter.other?.includes('LETTERA_ADV_SCADUTA_CLIENTI_CF_REALI');
    if (hasAdvExpired && !filter.other?.includes('LETTERA_ADV_SCADUTA_CLIENTI_CF_TECNICI')) {
      filter.other = [...(filter.other ?? []), 'LETTERA_ADV_SCADUTA_CLIENTI_CF_TECNICI'];
    }

    return await documentsRepository.getCommunicationDocuments(
      thunkApi,
      filter
    );
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
